import { incYenOf } from '../../../lib/pricing';
const corporate = {
  // page.tsx
  'corporate.page.lastUpdated': '最終更新: 2026年6月13日',
  'corporate.page.backToTop': 'ページトップへ戻る',

  // JSON-LD
  'corporate.jsonld.serviceName': '法人研修｜執事流ホスピタリティ研修',
  'corporate.jsonld.orgName': '一般社団法人全日本執事協会',
  'corporate.jsonld.serviceType': '企業向け接遇研修',
  'corporate.jsonld.areaServed': '日本',
  'corporate.jsonld.description': '執事流のホスピタリティを企業現場に移植する出張型・来校型の法人研修プログラム。半日220,000円〜・1日330,000円〜（税込）。',
  'corporate.jsonld.breadcrumb1': 'ホーム',
  'corporate.jsonld.breadcrumb2': 'お問い合わせ',
  'corporate.jsonld.breadcrumb3': '法人研修',

  // HeroSection
  'corporate.hero.homeLink': 'ホーム',
  'corporate.hero.contactLink': 'お問い合わせ',
  'corporate.hero.currentPage': '法人研修',
  'corporate.hero.title': '出張型 法人研修',
  'corporate.hero.titleEn': 'ON-SITE CORPORATE TRAINING',
  'corporate.hero.lead': 'プロの執事が貴社へ出向く出張型の研修プログラム。全国どこでも、プロの執事が培った接遇の型をビジネスマナーとして指導します。',
  'corporate.hero.ctaBtn': '出張型研修について問い合わせる',
  'corporate.hero.imgAlt': '研修会場で受講者の立ち姿を指導する日本人執事講師',
  'corporate.hero.badge1': '実技中心（演習8割）',
  'corporate.hero.badge2': '出張型（全国対応）・来校型どちらも可',
  'corporate.hero.badge3': '執事養成課程と同一の講師陣',

  // TravelTrainingSection
  'corporate.travel.label': 'ON-SITE TRAINING',
  'corporate.travel.title': '出張研修とは',
  'corporate.travel.subtitleEn': 'Why On-Site Training',
  'corporate.travel.lead': '日本の執事学校・日本執事アカデミーの法人研修は、プロの執事講師が貴社へ出向く出張型が基本です。現場に合わせたカスタマイズと、受講者の移動負担のなさが最大の特長です。',
  'corporate.travel.point1.title': '現場に合わせたカスタマイズ',
  'corporate.travel.point1.desc': '貴社の実際の応接室・受付・車寄せなど、現場の動線に合わせて研修内容を設計します。事前ヒアリングをもとに、貴社ならではの課題に即したプログラムをご用意します。',
  'corporate.travel.point2.title': '移動不要・全国どこでも対応',
  'corporate.travel.point2.desc': '講師が貴社・貴施設へ伺うため、受講者が会場へ移動する必要がありません。全国どこでも出張いたします（交通費・宿泊費は実費別途）。',
  'corporate.travel.point3.title': '現場実地での指導',
  'corporate.travel.point3.desc': '実際の業務空間で実技指導を行うため、研修で学んだ所作をそのまま現場の動きに落とし込めます。座学だけでは得られない、実践的な定着を図ります。',
  'corporate.travel.img1Alt': '企業の会議室で執事講師から接遇研修の指導を受ける参加者',
  'corporate.travel.img2Alt': 'オフィスの受付スペースで所作指導を行う執事講師',
  'corporate.travel.note': '来校型もご選択いただけます。本研修は執事資格を付与するものではありませんが、ご希望に応じて受講証（参加証明）を発行します。',

  // PainPoints
  'corporate.pain.label': 'CHALLENGES',
  'corporate.pain.title': 'こんな課題をお持ちではありませんか',
  'corporate.pain.subtitleEn': 'Common Challenges',
  'corporate.pain.lead': '接遇品質の向上は多くの企業が直面する経営課題です。執事流の研修は、型として定着する実技中心のアプローチでその解決を支援します。',
  'corporate.pain.item1': 'VIP・富裕層対応の品質を底上げしたい',
  'corporate.pain.item2': '開業・リニューアルに向けて接遇の型を短期間で整えたい',
  'corporate.pain.item3': '座学中心のマナー研修では現場が変わらなかった',
  'corporate.pain.item4': '管理職に「チームで品質を保つ仕組み」を持たせたい',

  // IndustryCards
  'corporate.industry.label': 'INDUSTRY PROGRAMS',
  'corporate.industry.title': '貴社の業種に合わせた研修設計',
  'corporate.industry.subtitleEn': 'Tailored for Your Industry',
  'corporate.industry.lead': '業種ごとに求められる接遇の質は異なります。貴社の業態・顧客層・課題に最適化したプログラムを、8つの業種別テンプレートから設計します。また、高級飲食、ブライダル、会員制サービスなど、人に丁寧に接するあらゆる業種にも対応可能です。',
  'corporate.industry.viewDetail': '詳しく見る',
  'corporate.industry.otherNote': '上記以外の業種についてもご相談ください。お問い合わせフォームの業種プルダウンに「その他」をご用意しています。',
  'corporate.industry.hotel.name': 'ホテル・旅館',
  'corporate.industry.hotel.desc': '開業前研修からバトラーサービスの型まで',
  'corporate.industry.hotel.imgAlt': '客室でウェルカムティーを提供する所作を指導するホテル向け研修風景',
  'corporate.industry.residence.name': '高級レジデンス',
  'corporate.industry.residence.desc': 'コンシェルジュ・フロントの接遇品質を統一',
  'corporate.industry.residence.imgAlt': 'レジデンスのエントランスで入居者を出迎えるコンシェルジュの所作研修',
  'corporate.industry.finance.name': '金融・プライベートバンク',
  'corporate.industry.finance.desc': '富裕層対応の信頼を所作から築く',
  'corporate.industry.finance.imgAlt': '応接室で顧客にお茶を出す所作を練習するプライベートバンカー向け研修',
  'corporate.industry.retail.name': '百貨店外商・高級小売',
  'corporate.industry.retail.desc': 'お得意様対応と訪問の作法',
  'corporate.industry.retail.imgAlt': '商品を両手で丁寧に提示する所作を練習する外商担当者向け研修風景',
  'corporate.industry.luxurySales.name': 'ラグジュアリー営業',
  'corporate.industry.luxurySales.desc': '高級車・宝飾・不動産の商談体験を設計',
  'corporate.industry.luxurySales.imgAlt': 'ショールームで顧客をエスコートする所作を指導するラグジュアリー営業向け研修',
  'corporate.industry.clinic.name': '医療・美容クリニック',
  'corporate.industry.clinic.desc': '自由診療の接遇を院内に定着',
  'corporate.industry.clinic.imgAlt': '受付で患者様に笑顔で対応する所作を練習するクリニックスタッフ向け研修',
  'corporate.industry.automotive.name': '自動車・モビリティ',
  'corporate.industry.automotive.desc': 'ブランド体験・イベントのおもてなしを高める',
  'corporate.industry.automotive.imgAlt': 'ブランド体験施設で来場者を出迎える所作を指導する自動車業界向け研修',
  'corporate.industry.chauffeur.name': 'ハイヤー・送迎',
  'corporate.industry.chauffeur.desc': '乗降の所作と車内の気配りを磨く',
  'corporate.industry.chauffeur.imgAlt': 'ドアサービスの所作を丁寧に指導するハイヤードライバー向け研修風景',

  // TrainingModules
  'corporate.modules.label': 'TRAINING MODULES',
  'corporate.modules.title': '研修プログラム',
  'corporate.modules.subtitleEn': 'Six Core Modules',
  'corporate.modules.lead': '半日＝2モジュール、1日＝4モジュールを標準とし、業種・課題に合わせて自由に組み合わせ可能です。',
  'corporate.modules.m1.title': '執事流の立ち居振る舞いと身だしなみ',
  'corporate.modules.m1.desc': '第一印象を決める立ち姿・歩き方・所作を、執事の基準で一つひとつ点検し矯正します。写真撮影によるビフォーアフター比較で、受講生ご自身が変化を実感できる構成です。',
  'corporate.modules.m2.title': 'VIP・富裕層対応の原則',
  'corporate.modules.m2.desc': '呼称・敬語・距離感・守秘義務など、信頼を損なわないための原則を実例をもとに学びます。富裕層ゲストが無意識に感じ取る「違和感」を排除し、安心感を与える接し方を身につけます。',
  'corporate.modules.m3.title': 'ティー＆テーブルサービス実技',
  'corporate.modules.m3.desc': 'お茶出しと卓上の整えを実技で行い、所作の精度を体に入れます。茶器の扱い、温度管理、美しい注ぎ方から下膳のタイミングまで、一連の流れを反復練習します。',
  'corporate.modules.m4.title': 'クレーム・想定外対応',
  'corporate.modules.m4.desc': '初動の重要性と代替案の組み立て方を、貴社の実際の事例を題材にロールプレイングします。感情的にならず、ゲストの真の要望を見抜いて最短で解決へ導く思考法を訓練します。',
  'corporate.modules.m5.title': '電話・メール・チャットの品格',
  'corporate.modules.m5.desc': '言葉選びと型を整え、文章にも品格を持たせます。声のトーン・間の取り方・文面の構成まで、非対面コミュニケーションだからこそ差がつく要素を体系的に指導します。',
  'corporate.modules.m6.title': 'チームで提供するおもてなし',
  'corporate.modules.m6.desc': '管理職向けに、基準づくり・観察・フィードバックのサイクルでサービス品質を保つ仕組みを扱います。属人化を防ぎ、チーム全体で一定水準を維持するマネジメント手法を学びます。',

  // PricingTable
  'corporate.pricing.label': 'PRICING',
  'corporate.pricing.title': '料金プラン',
  'corporate.pricing.subtitleEn': 'Transparent Pricing',
  'corporate.pricing.lead': 'すべて税込価格での明確な料金体系です。貴社のご予算と目標に合わせて最適なプランをお選びいただけます。',
  'corporate.pricing.header.plan': 'プラン',
  'corporate.pricing.header.duration': '時間',
  'corporate.pricing.header.price': '料金（税込）',
  'corporate.pricing.header.note': '内容',
  'corporate.pricing.recommended': '標準',
  'corporate.pricing.currency': '円',
  'corporate.pricing.plan1.name': '半日プラン',
  'corporate.pricing.plan1.duration': '3時間',
  'corporate.pricing.plan1.note': '2モジュール選択',
  'corporate.pricing.plan2.name': '1日プラン',
  'corporate.pricing.plan2.duration': '6時間',
  'corporate.pricing.plan2.note': '4モジュール選択',
  'corporate.pricing.plan3.name': '2日間パッケージ',
  'corporate.pricing.plan3.duration': '12時間（2日間）',
  'corporate.pricing.plan3.note': '全6モジュール受講可',
  'corporate.pricing.plan4.name': '開業前集中',
  'corporate.pricing.plan4.duration': '18時間（3日間）',
  'corporate.pricing.plan4.note': '開業準備に特化した集中設計',
  'corporate.pricing.plan5.name': '継続プログラム',
  'corporate.pricing.plan5.duration': '月1回半日×6ヶ月',
  'corporate.pricing.plan5.note': '定着と改善を繰り返す長期設計',
  'corporate.pricing.options.title': 'オプション',
  'corporate.pricing.options.currency': '円（税込）',
  'corporate.pricing.opt1.name': '覆面サービス診断',
  'corporate.pricing.opt1.price': `${incYenOf('ct-opt-mystery')}〜`,
  'corporate.pricing.opt1.note': '現場診断＋報告書',
  'corporate.pricing.opt2.name': '教材カスタム開発',
  'corporate.pricing.opt2.price': `${incYenOf('ct-opt-material')}〜`,
  'corporate.pricing.opt2.note': '貴社専用のテキスト・マニュアル制作',
  'corporate.pricing.conditions.title': '共通条件',
  'corporate.pricing.conditions.dispatch': '出張（全国対応・交通費宿泊費は実費別途）',
  'corporate.pricing.conditions.capacity': '推奨人数12名まで（超過は2班制等をご提案）',
  'corporate.pricing.conditions.payment': 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  'corporate.pricing.conditions.cancel': 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
  'corporate.pricing.ctaBtn': '研修について問い合わせる',

  // FlowSteps
  'corporate.flow.label': 'FLOW',
  'corporate.flow.title': '出張研修のご利用の流れ',
  'corporate.flow.subtitleEn': 'From Inquiry to On-Site Delivery',
  'corporate.flow.lead': 'お問い合わせから実施後レポートまで、5つのステップで着実に進めます。出張の場合は講師が研修当日に貴社・貴施設へ伺い、現場に合わせてプログラムをカスタマイズしてお届けします。',
  'corporate.flow.step1.title': 'お問い合わせ',
  'corporate.flow.step1.desc': 'フォームまたはお電話・メールにてご連絡ください。',
  'corporate.flow.step2.title': 'ヒアリング',
  'corporate.flow.step2.desc': '対象人数・課題・希望時期に加え、出張先の会場条件などをオンラインまたはお電話で伺います。',
  'corporate.flow.step3.title': 'プログラム提案・お見積り',
  'corporate.flow.step3.desc': 'ヒアリング内容をもとに、現場に合わせてカスタマイズした研修プログラムとお見積りをご提案します。',
  'corporate.flow.step4.title': '出張実施（来校も選択可）',
  'corporate.flow.step4.desc': '講師が貴社・貴施設へ出張し、現場に即した実技研修を実施します。来校での受講もご希望に応じて承ります。',
  'corporate.flow.step5.title': '実施後レポート',
  'corporate.flow.step5.desc': '研修の総括と改善提案をまとめたレポートをお届けします。',

  // ContactForm
  'corporate.contact.label': 'CONTACT',
  'corporate.contact.title': 'お問い合わせ',
  'corporate.contact.subtitleEn': 'Inquiry Form',
  'corporate.contact.lead': '以下のフォームに必要事項をご入力のうえ、送信ください。',
  'corporate.contact.phoneLead': 'フォームのほか、お電話',
  'corporate.contact.phoneOr': 'またはメール',
  'corporate.contact.phoneAlso': 'でも承ります。',
  'corporate.contact.hours': '受付時間: 平日 10:00〜17:00',
  'corporate.contact.company': '会社名',
  'corporate.contact.company.placeholder': '例: 株式会社〇〇',
  'corporate.contact.department': '部署・役職',
  'corporate.contact.department.placeholder': '例: 人事部 研修担当',
  'corporate.contact.name': 'ご担当者名',
  'corporate.contact.name.placeholder': '例: 執事 太郎',
  'corporate.contact.name.required': '必須',
  'corporate.contact.name.error': 'ご担当者名は必須です',
  'corporate.contact.email': 'メールアドレス',
  'corporate.contact.email.placeholder': '例: taro@example.com',
  'corporate.contact.email.required': '必須',
  'corporate.contact.email.error': 'メールアドレスは必須です',
  'corporate.contact.email.invalid': '有効なメールアドレスを入力してください',
  'corporate.contact.phone': '電話番号',
  'corporate.contact.phone.placeholder': '例: 090-1234-5678',
  'corporate.contact.phone.required': '必須',
  'corporate.contact.phone.error': '電話番号は必須です',
  'corporate.contact.industry': '業種',
  'corporate.contact.industry.required': '必須',
  'corporate.contact.industry.error': '業種をお選びください',
  'corporate.contact.format': '希望形式',
  'corporate.contact.participants': '想定人数',
  'corporate.contact.participants.placeholder': '例: 10名',
  'corporate.contact.timeline': '検討時期',
  'corporate.contact.timeline.placeholder': '例: 来月、今期中、未定',
  'corporate.contact.message': 'ご相談内容（任意）',
  'corporate.contact.message.placeholder': '研修の目的やご要望、ご不明な点など、自由にご記入ください。',
  'corporate.contact.message.error': '500文字以内で入力してください',
  'corporate.contact.submit.error': '送信中にエラーが発生しました。お手数ですが再度お試しいただくか、お電話にてお問い合わせください。',
  'corporate.contact.submit': 'この内容で送信する',
  'corporate.contact.submitting': '送信中...',
  'corporate.contact.industry.select': '選択してください',
  'corporate.contact.industry.hotel': 'ホテル・旅館',
  'corporate.contact.industry.residence': '高級レジデンス',
  'corporate.contact.industry.finance': '金融',
  'corporate.contact.industry.retail': '百貨店・小売',
  'corporate.contact.industry.luxurySales': 'ラグジュアリー営業',
  'corporate.contact.industry.clinic': '医療・クリニック',
  'corporate.contact.industry.automotive': '自動車・モビリティ',
  'corporate.contact.industry.chauffeur': 'ハイヤー・送迎',
  'corporate.contact.industry.other': 'その他',
  'corporate.contact.format.select': '選択してください',
  'corporate.contact.format.dispatch': '出張',
  'corporate.contact.format.onsite': '来校',
  'corporate.contact.format.undecided': '未定',

  // FAQSection
  'corporate.faq.label': 'FAQ',
  'corporate.faq.title': 'よくあるご質問',
  'corporate.faq.subtitleEn': 'Frequently Asked Questions',
  'corporate.faq.otherNote': 'その他のご質問はフォームよりお寄せください',
  'corporate.faq.q1': '1回の研修で何名まで受講できますか？',
  'corporate.faq.a1': '実技の品質を保つため12名までを推奨しています。それ以上の場合は2班制や複数回開催などの形式をご提案しますのでご相談ください。',
  'corporate.faq.q2': '地方への出張は可能ですか？',
  'corporate.faq.a2': 'はい、全国へ出張いたします。講師の交通費・宿泊費は実費を別途申し受けます。',
  'corporate.faq.q3': '研修内容のカスタマイズはできますか？',
  'corporate.faq.a3': 'はい。事前ヒアリングのうえ、6つのモジュールの組合せや貴社事例の組み込みなど、課題に合わせて設計いたします。',
  'corporate.faq.q4': '支払い方法を教えてください。',
  'corporate.faq.a4': '請求書払い（銀行振込）にて承ります。分割払い・クレジットカードはご利用いただけません。',

  // CTASection
  'corporate.cta.label': 'GET STARTED',
  'corporate.cta.title': 'まずはお気軽にご相談ください',
  'corporate.cta.lead': '貴社の課題をお聞かせいただければ、最適な研修プランを無料でご提案いたします。',
  'corporate.cta.inquiryBtn': '研修について問い合わせる',
  'corporate.cta.coursesBtn': '個人向けコースを見る',

  // RelatedPages
  'corporate.related.label': 'RELATED',
  'corporate.related.title': '関連ページ',
  'corporate.related.subtitleEn': 'See Also',
  'corporate.related.viewDetail': '詳しく見る',
  'corporate.related.coursesLink': '個人向けコース（執事養成課程）を見る',
  'corporate.related.page1.title': 'アカデミーについて',
  'corporate.related.page1.desc': '日本執事アカデミーの理念と概要',
  'corporate.related.page2.title': 'カリキュラム',
  'corporate.related.page2.desc': '執事養成課程の全体像',
  'corporate.related.page3.title': '講師紹介',
  'corporate.related.page3.desc': '順次公開予定',
  'corporate.related.page4.title': 'アクセス',
  'corporate.related.page4.desc': '東京・お台場の校舎へのご案内',
};

export default corporate;
